import { Routes } from 'constants/global.constants'
import axios from 'lib/axios'

export interface UpdateAdminManagementPermissionBody {
  has_admin_platform_management: boolean
}

export interface UpdateAdminManagementPermissionParams {
  companyId: number
  userId: number
  body: UpdateAdminManagementPermissionBody
}

export const fetchUpdateAdminManagementPermission = async ({
  companyId,
  userId,
  body,
}: UpdateAdminManagementPermissionParams): Promise<any> => {
  const response = await axios.put(
    `${Routes.users}/has-admin-platform-management/${companyId}/${userId}`,
    body
  )
  return response.data
}

